<script lang="ts">
  import { getTimeZone } from "../data/clock";
  import { ensureDate, localTime } from "../support/dates";
  import { settings } from "../data/settings";

  export let timeZone = getTimeZone();
  export let time: Date;
  export let overrides = {};

  $: amPm = { ...$settings, ...overrides }.amPm;

  $: date = ensureDate(time);
  $: full = localTime(date, { timeZone: $timeZone });
  $: label = amPm ? full : full.replace(/(.+?)\s*(AM|PM)/, "$1");
</script>

<time datetime={date.toISOString()}>
  {label}
</time>
